import React, { useState } from "react";
import { useNavigate, Link, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { ArrowRight } from "@phosphor-icons/react";

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Sesión iniciada");
      navigate("/");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "No se pudo iniciar sesión");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid md:grid-cols-2 bg-background text-foreground">
      <div className="hidden md:flex flex-col justify-between p-12 border-r-2 border-foreground bg-foreground text-background">
        <div>
          <div className="display text-6xl leading-none">RUTA</div>
          <div className="label-mono mt-3 opacity-80">Menos dudas. Más dirección.</div>
        </div>
        <div>
          <div className="display text-4xl leading-tight max-w-md">
            ¿Voy por el<br />camino correcto?
          </div>
          <p className="mt-4 max-w-md text-sm opacity-80 leading-relaxed">
            Encuentra claridad, evalúa tus opciones y construye con confianza. Ruta te acompaña desde la idea hasta la escala.
          </p>
        </div>
        <div className="label-mono opacity-70">Latinoamérica · Español</div>
      </div>

      <div className="flex items-center justify-center p-6 md:p-12">
        <form onSubmit={submit} className="w-full max-w-md space-y-6" data-testid="login-form">
          <div>
            <div className="label-mono text-muted-foreground">Iniciar sesión</div>
            <h1 className="display text-4xl md:text-5xl mt-2">Bienvenido de nuevo</h1>
          </div>

          <div className="space-y-4">
            <div>
              <label className="label-mono block mb-2">Correo</label>
              <input
                type="email"
                required
                className="input-brut"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="login-email"
              />
            </div>
            <div>
              <label className="label-mono block mb-2">Contraseña</label>
              <input
                type="password"
                required
                className="input-brut"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid="login-password"
              />
            </div>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="btn-primary w-full flex items-center justify-center gap-2"
            data-testid="btn-login-submit"
          >
            {loading ? "Entrando…" : "Entrar"}
            <ArrowRight size={16} weight="bold" />
          </button>

          <div className="text-sm">
            ¿Aún no tienes cuenta?{" "}
            <Link to="/registro" className="font-semibold underline decoration-2 underline-offset-4" data-testid="link-register">
              Crea una cuenta
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
}
